<template>
  <div class="faq-module f-column-b">
    <block-head-line title="常见问题" :more-btn-url="moreBtnUrl" />
    <ul class="faq-list">
      <li v-for="data in dataList" :key="data.id" class="list-item">
        <Link class="text-cut" :to="{path:`/info/detail/${code}`, query: {id: data.id}}" :title="data.title" target="_blank">
          {{ data.title }}
        </Link>
      </li>
    </ul>
  </div>
</template>

<script>
import { NAV_MENU_CODE } from "@/utils/constant";
import infoApi from "@/api/information";
import Link from "@/layout/components/LayoutHead/HeadNav/Link.vue";
import BlockHeadLine from "@/views/home/components/BlockHeadLine.vue";

export default {
  name: "FAQ",
  components: { BlockHeadLine, Link },
  props: {
  },
  data() {
    return {
      code: NAV_MENU_CODE.FAQ,
      dataList: []
    };
  },
  // 监听属性 类似于data概念
  computed: {
    moreBtnUrl() {
      return "/info/list/" + this.code
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.loadListData()
  },
  // 方法集合
  methods: {
    loadListData() {
      const params = {
        pageNo: 1,
        pageSize: 8,
        columnId: this.$getMenuIdByCode(this.code)
      };
      infoApi.page({ ...params }).then(res => {
        this.dataList = res.data?.list ?? []
      })
    }
  }
};
</script>

<style scoped lang="scss">
.faq-module{
	width: 100%;
  height: 300px;
  .faq-list{
    flex: 1;
    padding-top: 8px;
    width: 100%;
    overflow: hidden;
    .list-item{
      position: relative;
      padding-left:14px;
      line-height: 32px;
      &::before{
        content: '';
        display: block;
        width: 4px;
        height: 4px;
        border-radius: 50%;
        background-color: #999;
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
      }
      a{
        width: 100%;
        color: #333;
        display: block;
      }
      &:hover{
        &:before{
          background-color: $--color-primary;
        }
        a{
          color: $--color-primary;
        }
      }
    }
  }
}
</style>
